import { render, staticRenderFns } from "./TheWizardNav.vue?vue&type=template&id=61613ce0&"
import script from "./TheWizardNav.vue?vue&type=script&lang=js&"
export * from "./TheWizardNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports